import React from 'react';

export const useMaxItemsPerRow = (
  containerRef: React.RefObject<HTMLDivElement>,
  seriesKeys: string[],
  columnGap = 10
): { maxItemsPerRow: number; isReady: boolean } => {
  const [maxItemsPerRow, setMaxItemsPerRow] = React.useState(4);
  const [isReady, setIsReady] = React.useState(false);

  React.useEffect(() => {
    const calculateMaxItems = () => {
      if (!containerRef.current) {
        setIsReady(false);
        return;
      }

      const container = containerRef.current;
      const containerWidth = container.offsetWidth - 64; // Subtract padding (px: 8 = 32px each side)

      if (containerWidth <= 0) {
        setIsReady(false);
        return;
      }

      // Create a temporary element to measure item width
      const tempElement = document.createElement('div');
      tempElement.style.position = 'absolute';
      tempElement.style.visibility = 'hidden';
      tempElement.style.whiteSpace = 'nowrap';
      tempElement.style.fontSize = '12px';
      tempElement.style.padding = '4px';
      tempElement.style.display = 'inline-flex';
      tempElement.style.alignItems = 'center';
      tempElement.style.gap = '6px';

      // Use the longest series name to estimate max width
      const longestName = seriesKeys.reduce((a, b) => (a.length > b.length ? a : b), '');
      tempElement.textContent = longestName;
      document.body.appendChild(tempElement);

      const itemWidth = tempElement.offsetWidth + 12; // Add square width (12px)
      document.body.removeChild(tempElement);

      // Calculate how many items fit: (containerWidth + gap) / (itemWidth + gap)
      const itemsThatFit = Math.floor((containerWidth + columnGap) / (itemWidth + columnGap));
      const calculatedMax = Math.max(1, Math.min(itemsThatFit, seriesKeys.length));

      setMaxItemsPerRow(calculatedMax);
      setIsReady(true);
    };

    calculateMaxItems();
  }, [containerRef, seriesKeys, columnGap]);

  return { maxItemsPerRow, isReady };
};
